module.exports = __webpack_public_path__ + "static/media/accept.0608b56e.svg";